import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import WhoWeAre from '../components/WhoWeAre';
import Team from '../components/Team';
import Supporters from '../components/Supporters';
import WikiFeed from '../components/WikiFeed';
import Games from '../components/Games';
import Stats from '../components/Stats';
import DiscordCTA from '../components/DiscordCTA';
import Footer from '../components/Footer';

export default function Home() {
  useEffect(() => { document.title = 'TO Studios — Roblox Türkiye'; }, []);
  return (
    <div className="min-h-screen" style={{ background: 'var(--bg)', color: 'var(--text)' }}>
      <Header />
      <main>
        <Hero />
        <WhoWeAre />
        <Team />
        <Supporters />
        <WikiFeed />
        <Games />
        <Stats />
        <DiscordCTA />
      </main>
      <Footer />
    </div>
  );
}
